mutation EntityTagInvoiceSignCreate ($input: EntityTagInvoiceSigningCreateInput!) {
  entityTagInvoiceSigningCreate(
    input: $input
  ) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}